import React, { Component, Fragment } from 'react';
import { get } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';

import {
  styles,
  SecondaryText,
  ToggleIcon,
  ListDivider,
} from '../Sidebar.styles';

const isNested = nestedList => {
  return nestedList && nestedList.length > 0;
};

class ListNested extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu(event) {
    const id = get(event, 'currentTarget.dataset.id');
    const stateName = this.getOpenName(id);

    this.setState(prevState => ({
      [stateName]: !prevState[stateName],
    }));
  }

  getOpenName(id) {
    return `open_${id}`;
  }

  formatUserCount(number) {
    try {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } catch (error) {
      return '';
    }
  }

  renderNestedList(list, open) {
    const { classes, onItemClick } = this.props;

    return (
      <Collapse in={open} timeout="auto">
        <List className={classes.nestedList} disablePadding>
          {list.map(item => (
            <ListItem
              className={classes.listItem}
              key={item.id}
              onClick={() => onItemClick(item)}
              button
            >
              <ListItemText disableTypography>
                {item.name}
              </ListItemText>

              <SecondaryText>{this.formatUserCount(item.user_count)}</SecondaryText>
            </ListItem>
          ))}
        </List>
      </Collapse>
    );
  }

  renderMainListItem(item, open, key) {
    const { classes } = this.props;
    const nested = isNested(item.nestedList);

    const nestedProps = {};
    if (nested) {
      nestedProps.button = true;
      nestedProps.onClick = this.toggleMenu;
    }

    return (
      <ListItem
        {...nestedProps}
        className={classes.listItem}
        classes={{ button: classes.listItemButton }}
        data-id={key}
      >
        <ToggleIcon isOpen={open}>
          <ExpandLess />
        </ToggleIcon>

        <ListItemText disableTypography>
          {item.text}
        </ListItemText>
        <SecondaryText>{item.textSecondary}</SecondaryText>
      </ListItem>
    );
  }

  render() {
    const { data } = this.props;

    return (
      <List disablePadding>
        {data.map((item, key) => {
          const nested = isNested(item.nestedList);
          const open = this.state[this.getOpenName(key)];

          return (
            <Fragment key={item.text}>
              {this.renderMainListItem(item, open, key)}
              {nested && this.renderNestedList(item.nestedList, open)}
              <ListDivider />
            </Fragment>
          );
        })}
      </List>
    );
  }
}

export default withStyles(styles)(ListNested);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Sidebar/ListNested/ListNested.js